const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  //(value.isArray()  && value.length === 0) ||
  (typeof value === "array"  && value.length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

module.exports = isEmpty;

// function isEmpty(value) {
//   return value === undefined || value === null)
// }



// WEBPACK FOOTER //
// ./src/components/common/is-empty.js